import { render, staticRenderFns } from "./PositionsMaps.vue?vue&type=template&id=6246840d"
import script from "./PositionsMaps.vue?vue&type=script&lang=js"
export * from "./PositionsMaps.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports